import {Directive, HostListener} from '@angular/core';
import {NgModel} from '@angular/forms';

@Directive({
  selector: '[wsdPositiveNumbersOnly]'
})
export class PositiveNumbersOnlyDirective {

  constructor(private ngModel: NgModel) {
  }

  @HostListener('focus') onFocus() {
    if (!this.ngModel.model) {
      this.ngModel.update.emit(null);
    }
  }

  @HostListener('keyup') onKeyUp() {
    if (this.ngModel.model < 0) {
      this.ngModel.update.emit(0);
    }
  }

  @HostListener('blur') onBlur() {
    if (!this.ngModel.model || this.ngModel.model < 0) {
      this.ngModel.update.emit(0);
    }
  }
}
